import type { PropsWithChildren, ReactElement, ReactNode } from "react";

import type { ILeadScoreTooltipFooterProps } from "../LeadScoreTooltipFooter/LeadScoreTooltipFooter";
import LeadScoreTooltipFooter from "../LeadScoreTooltipFooter/LeadScoreTooltipFooter";

import { StyledTooltipContentWrapper, StyledTooltipWrapper } from "./styles";

interface IProps extends ILeadScoreTooltipFooterProps {
    header: ReactNode;
}

const LeadScoreTooltipLayout = ({
    header,
    score,
    children,
    ...footerProps
}: PropsWithChildren<IProps>): ReactElement => (
    <StyledTooltipWrapper>
        <StyledTooltipContentWrapper
            flexDirection="column"
            gap="16px"
        >
            {header}

            {children}
        </StyledTooltipContentWrapper>

        <LeadScoreTooltipFooter
            {...footerProps}
            score={score}
        />
    </StyledTooltipWrapper>
);

export default LeadScoreTooltipLayout;
